import { Rendered } from "../rendered";

export class Page {
  private _id: number;
  private _slug: string;
  private _title: Rendered
  private _content: Rendered;
  
  constructor(data: any = null) {
    if (data) {
      this.normalize(data);
    }
  }  

  public normalize(data: any = null) {
    for (const prop in data) {
      if (! (data[prop] instanceof Object) && ! (data[prop] instanceof Array)) {
        this[prop] = data[prop];      
      } else if ('title' === prop || 'content' === prop) {
        this[prop] = new Rendered(data[prop]);
      }
    }
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get slug(): string {
    return this._slug;
  }

  set slug(value: string) {
    this._slug = value;
  }
  
  get title(): Rendered {
    return this._title;
  }

  set title(value: Rendered) {
    this._title = value;
  }
  
  get content(): Rendered {
    return this._content;
  }

  set content(value: Rendered) {
    this._content = value;
  }
}
